var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_456_",
    d: "M26,4.3c0-1-0.8-1.8-1.7-1.8H18c-0.3,0-0.6,0.1-0.8,0.2c-0.3-0.2-0.5-0.2-0.8-0.2h-6.3c0,0,0,0,0,0V2.4 c0-0.9,0-1.6-0.5-2C9.1,0,8.6,0,7.5,0h-5C0.4,0,0,0.4,0,2.5v20.9C0,25.7,0.5,26,2.5,26h21.3c2,0,2.2-0.7,2.2-2.5V8.7 c0-0.1,0-0.2,0-0.2h0V4.3z M24.3,4.3v2.4H18V4.3H24.3z M10.1,4.3h6.3v2.4l-6.3,0V4.3z M24.3,23.5c0,0.3,0,0.6,0,0.8 c-0.1,0-0.3,0-0.5,0H2.5c-0.3,0-0.6,0-0.8,0c0-0.2,0-0.6,0-0.8V2.5c0-0.3,0-0.6,0-0.8c0.2,0,0.5,0,0.8,0h5c0.3,0,0.6,0,0.8,0 c0,0.2,0,0.4,0,0.7v1.7c0,0,0,0.1,0,0.1v2.5c0,0,0,0.1,0,0.1v0.1c0,1,0.8,1.7,1.7,1.7h14.3V23.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/Tabs.91a9dff61ca54f89af0d3c167a6d7a32.svg";
export { ForwardRef as ReactComponent };